import moment from 'moment';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import {
  INITIALIZE_SUCCESS, INITIALIZE_FAILURE, INITIALIZE_REQUEST,
  FETCH_PURCHASES_REQUEST, FETCH_PURCHASES_FAILURE, FETCH_PURCHASES_SUCCESS,
  SET_PERIOD,
} from './constants';

import { getCafeGuestPurchases, getCafePurchases, getStorePurchases, getXapValue } from './api';
import { custom } from '../../utils/Api';

const getDates = (startDate, endDate) => {
  const dateArray = [];
  const currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    dateArray.push({
      dateString: moment(currentDate).format('DD/MM/YY'),
      date: moment(currentDate),
      isWeekend: currentDate.getDay() === 6 || currentDate.getDay() === 0,
      dayOfWeek: moment(currentDate).format('ddd'),
    });
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dateArray;
};

export const setPeriod = (start, end) => ({
  type: SET_PERIOD,
  start,
  end,
  datesBetween: getDates(start, end),
});

export const fetchPurchasesRequest = () => ({
  type: FETCH_PURCHASES_REQUEST,
});

export const fetchPurchasesSuccess = (employeePurchases, guestPurchases) => ({
  type: FETCH_PURCHASES_SUCCESS,
  employeePurchases,
  guestPurchases,
});

export const fetchPurchasesFailure = error => ({
  type: FETCH_PURCHASES_FAILURE,
  error,
});

export const requestEntries = (start, end, type) => async (dispatch, getState) => {
  try {
    dispatch(fetchPurchasesRequest());
    const {
      loginReducer: {
        user: { DefaultEmployeeDetailID },
      },
      teriaReducer: { showCafes, showStores },
    } = getState();

    let employeePurchases = [];
    let guestPurchases = [];
    if (type === 'CAFE' && showCafes) {
      employeePurchases = get(await custom(getCafePurchases(start, end, DefaultEmployeeDetailID)), 'data.value', []);
      guestPurchases = get(await custom(getCafeGuestPurchases(start, end, DefaultEmployeeDetailID)), 'data.value', []);
    } else if (type === 'STORE' && showStores) {
      employeePurchases = get(await custom(getStorePurchases(start, end, DefaultEmployeeDetailID)), 'data.value', []);
      guestPurchases = []; // no guest purchases available for stores at the moment
    }
    dispatch(fetchPurchasesSuccess(
      employeePurchases,
      guestPurchases,
    ));
  } catch (error) {
    dispatch(fetchPurchasesFailure(error));
  }
};

export const changePeriod = (start, end, type) => async (dispatch) => {
  dispatch(setPeriod(start.startOf('day'), end.endOf('day')));
  dispatch(requestEntries(start.startOf('day'), end.endOf('day'), type));
};

export const initializeRequest = () => ({
  type: INITIALIZE_REQUEST,
});

export const initializeSuccess = (periodFrom, showStores, showCafes) => ({
  type: INITIALIZE_SUCCESS,
  periodFrom,
  showStores,
  showCafes,
});

export const initializeFailure = error => ({
  type: INITIALIZE_FAILURE,
  error,
});

export const initialize = () => async (dispatch, getState) => {
  try {
    dispatch(initializeRequest());
    const requests = [
      custom(getXapValue('Pay.PeriodFrom')),
    ];
    const [xapRes] = await Promise.all(requests);
    const periodFrom = get(xapRes, 'data.value[0].Value') || 1;
    let startDate = moment().date(periodFrom).add(-1, 'months').startOf('day');
    let endDate = moment().date(periodFrom - 1).endOf('day');
    if (endDate.isSameOrBefore(moment())) {
      startDate = startDate.add(1, 'months');
      endDate = startDate.clone().add(1, 'months').add(-1, 'days').endOf('day');
    }
    const { WebValuesReducer: { valuesByKey } } = getState();

    const showStores = get(valuesByKey, ['Hide.Teria.Store', 'Value']) !== 'true';
    const showCafes = get(valuesByKey, ['Hide.Teria.Cafeteria', 'Value']) !== 'true';

    let initialType;
    if (showCafes) {
      initialType = 'CAFE';
    } else if (showStores) {
      initialType = 'STORE';
    }
    dispatch(initializeSuccess(periodFrom, showStores, showCafes));
    dispatch(changePeriod(startDate, endDate, initialType));
  } catch (error) {
    dispatch(initializeFailure(get(error, 'message')));
  }
};

export const useTeriaState = () => useSelector(state => state.TeriaReducer);



// WEBPACK FOOTER //
// ./src/sites/teria/actions.js